export const layers = {
  applicationTop: 2000,
  blocking: 3000,
  alert: 9999
};